import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import GeneratedReportPanel from "./GeneratedReportPanel";

const generatedReportConfigs = {
  "preauth-report": {
    id: "preauth-report",
    label: "PreAuth Report",
    description: "Generate full pre-auth report",
    generate: "/preAuth/report",
    list: "/preAuth/report",
    file: "/preAuth/report/file",
    fields: ["dateRange", "payer", "format"],
    defaultFilters: {
      from_date: "",
      to_date: "",
      payer_id: "",
      format: "excel",
    },
  },
  "preauth-approved-items": {
    id: "preauth-approved-items",
    label: "PreAuth Approved Items",
    description: "Generate approved item report",
    generate: "/preAuth/approved-items/report",
    list: "/preAuth/approved-items/report",
    file: "/preAuth/approved-items/report/file",
    fields: ["dateRange", "payer", "format"],
    defaultFilters: {
      from_date: "",
      to_date: "",
      payer_id: "",
      format: "excel",
    },
  },
  "preauth-rejected-items": {
    id: "preauth-rejected-items",
    label: "PreAuth Rejected Items",
    description: "Generate rejected item report",
    generate: "/preAuth/rejected-items/report",
    list: "/preAuth/rejected-items/report",
    file: "/preAuth/rejected-items/report/file",
    fields: ["dateRange", "payer", "format"],
    defaultFilters: {
      from_date: "",
      to_date: "",
      payer_id: "",
      format: "excel",
    },
  },
  "claim-ready-submission": {
    id: "claim-ready-submission",
    label: "Ready Submission Claims",
    description: "Generate claims ready for submission",
    generate: "/claim/ready-submission/report",
    list: "/claim/ready-submission/report",
    file: "/claim/ready-submission/report/file",
    fields: ["dateRange", "payer", "batch", "format"],
    defaultFilters: {
      from_date: "",
      to_date: "",
      payer_id: "",
      batch_id: "",
      format: "excel",
    },
  },
  "claim-rejection-percentage": {
    id: "claim-rejection-percentage",
    label: "Claim Rejection Percentage",
    description: "Generate claim rejection percentage report",
    generate: "/claim/rejection-percentage/report",
    list: "/claim/rejection-percentage/report",
    file: "/claim/rejection-percentage/report/file",
    fields: ["dateRange", "payer", "format"],
    defaultFilters: {
      from_date: "",
      to_date: "",
      payer_id: "",
      format: "excel",
    },
  },
  "claim-excel-report": {
    id: "claim-excel-report",
    label: "Claims Excel Report File",
    description: "Download generated claim Excel report by ID",
    file: "/claim/excel/report",
    fields: ["reportId"],
    defaultFilters: {
      id: "",
    },
    fileOnly: true,
  },
};

const GeneratedReportRoute = ({ reportId }) => {
  const { t } = useTranslation();
  const report = generatedReportConfigs[reportId];

  if (!report) return null;

  return (
    <Box sx={{ p: 1 }}>
      <div className="mb-2 border-b border-slate-200 pb-2">
        <h1 className="text-base font-bold text-slate-900">
          {t(report.label)}
        </h1>
        {report.description && (
          <p className="mt-0.5 text-[12px] text-slate-500">
            {t(report.description)}
          </p>
        )}
      </div>
      <GeneratedReportPanel
        reports={[report]}
        activeReportId={report.id}
        showTabs={false}
      />
    </Box>
  );
};

export default GeneratedReportRoute;
